import React from 'react'
import i18next from 'i18next'
import { connect } from 'react-redux'
import hash from 'object-hash'
import { Modal, Button, Card, ListGroup } from 'react-bootstrap'
import ActionsDropdown from 'src/components/system_wide/actions_dropdown'
import SearchButton from 'src/components/system_wide/search_button'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import CheckboxFilter from 'src/components/system_wide/checkbox_filter'
import UserForm from './user_form'
import CapsForm from './caps_form'
import TargetForm from './target_form'
import ContractForm from './contract_form'
import ResetPasswordModal from './reset_password_modal'
import {
  setCurrentUser,
  createUser,
  updateUser,
  deleteUser,
  toggleShowForm,
  getUsers,
  resetCurrentUser,
  resetUsers,
  updateErrors,
  getAllCompentenceAreas,
} from 'src/store/users'
import { getAllRoles, getAllAcls } from 'src/store/roles_manager'
import { getAllBrands } from 'src/store/brand'
import { getConstants } from 'src/lib/constants'
import { Trans } from 'react-i18next'
import FilterGroup from '../system_wide/filter_group'
import { checkCapabilities, WithCapabilitiesWrapper } from 'src/enhancers/with_capabilities'

const { t } = i18next

const mstp = state => {
  let { is_management_account, business_role_priority } = state.userInfo
  let { total, users, show_form, current_user, errors, competence_areas } = state.users
  let { all_roles: roles, acls } = state.rolesManager
  let { all_brands: brands } = state.brands
  users = users.filter(user => !user.is_management_account || is_management_account)
  let can_manage = checkCapabilities(['manage_users'])
  return {
    total,
    users,
    show_form,
    current_user,
    roles,
    is_management_account,
    acls,
    errors,
    can_manage,
    business_role_priority,
    brands,
    competence_areas,
  }
}

class ManageUsers extends React.Component {
  state = {
    ready: false,
    show_modal: false,
    filter: '',
    filtered_areas: [],
    filtered_roles: [],
    filtered_brands: [],

    filters_hash: '',
    form: 'edit',
  }

  initialFiltersHash = ''
  tableRef = React.createRef()
  resetModalRef = React.createRef()
  tCaps = getConstants().t_caps

  async componentDidMount() {
    await this.props.dispatch(getAllRoles())
    await this.props.dispatch(getAllAcls())
    await this.props.dispatch(getAllBrands())
    await this.props.dispatch(getAllCompentenceAreas())
    this.setState(
      {
        filtered_roles: this.props.roles.map(r => r.id),
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_areas: this.props.competence_areas.map(a => a.id),
        ready: true,
      },
      () => {
        let { filtered_brands, filtered_roles, filtered_areas } = this.state
        filtered_brands.sort()
        filtered_roles.sort()
        filtered_areas.sort()
        this.initialFiltersHash = hash({
          filtered_brands,
          filtered_roles,
          filtered_areas,
        })
        this.updateFiltersHash()
        this.tableRef?.current?.refreshData()
      }
    )
  }

  componentWillUnmount() {
    this.props.dispatch(resetUsers())
  }

  updateFiltersHash = () => {
    let { filtered_brands, filtered_roles, filtered_areas } = this.state
    filtered_brands.sort()
    filtered_roles.sort()
    filtered_areas.sort()
    this.setState({ filters_hash: hash({ filtered_brands, filtered_roles, filtered_areas }) })
  }

  actions = [
    {
      name: 'view',
      icon: 'fas fa-eye',
      text: t('actions.view', 'Visualizza'),
      variant: 'outline-primary',
      onClick: rowData => {
        this.props.dispatch(setCurrentUser(rowData))
        this.setState({ form: 'view' })
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      name: 'edit',
      icon: 'fas fa-edit',
      text: t('actions.edit', 'Modifica'),
      variant: 'outline-warning',
      visible: () => this.props.can_manage,
      onClick: rowData => {
        this.props.dispatch(setCurrentUser(rowData))
        this.setState({ form: 'edit' })
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      name: 'target',
      icon: 'fas fa-bullseye',
      text: t('actions.target', 'Obiettivi'),
      variant: 'outline-secondary',
      visible: rowData => {
        return rowData.business_role_priority === 4 && this.props.can_manage
      },
      onClick: rowData => {
        this.props.dispatch(setCurrentUser(rowData))
        this.setState({ form: 'target' })
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      name: 'contract',
      icon: ' fas fa-file-contract',
      text: t('actions.contract_detection', 'Rilevazione contratti'),
      variant: 'outline-secondary',
      visible: rowData => {
        return rowData.business_role_priority === 4 && this.props.can_manage
      },
      onClick: rowData => {
        this.props.dispatch(setCurrentUser(rowData))
        this.setState({ form: 'contract' })
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      name: 'caps',
      icon: 'fas fa-shield-alt',
      text: t('actions.permission', 'Permessi'),
      variant: 'outline-primary',
      visible: () => this.props.is_management_account === true,
      onClick: rowData => {
        this.props.dispatch(setCurrentUser(rowData))
        this.setState({ form: 'caps' })
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      name: 'reset_password',
      icon: 'fas fa-key',
      text: t('actions.reset_password', 'Reset password'),
      variant: 'outline-success',
      visible: () => this.props.can_manage,
      onClick: rowData => {
        this.props.dispatch(setCurrentUser(rowData))
        this.toggleResetPasswordModal()
      },
    },
    {
      name: 'delete',
      icon: 'fas fa-trash-alt',
      text: t('actions.delete', 'Elimina'),
      variant: 'outline-danger',
      visible: () => this.props.can_manage,
      onClick: rowData => {
        this.props.dispatch(setCurrentUser(rowData))
        this.setState({ show_modal: true })
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  columns = [
    {
      title: '',
      className: 'd-none d-sm-block text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    // {
    //   title: t('components.users.username', 'Username'),
    //   className: 'd-none d-sm-block',
    //   style: { width: '12%' },
    //   sortable: true,
    //   data: 'username',
    // },
    {
      title: t('components.users.name', 'Nome'),
      className: 'd-none d-sm-block',
      style: { width: '15%' },
      sortable: true,
      data: 'first_name',
    },
    {
      title: t('components.users.surname', 'Cognome'),
      className: 'd-none d-sm-block',
      style: { width: '15%' },
      sortable: true,
      data: 'last_name',
    },
    {
      title: t('components.users.brand', 'Brand'),
      className: 'd-none d-sm-block',
      style: { width: '15%' },
      sortable: false,
      data: ({ rowData }) => {
        return this.props.brands
          .filter(b => (rowData?.brands ?? []).includes(b.id))
          .map(b => b.name)
          .join(', ')
      },
    },
    {
      title: t('components.users.role', 'Ruolo'),
      className: 'd-none d-sm-block',
      style: { width: '15%' },
      sortable: false,
      data: 'role_name',
    },
    {
      title: t('components.users.email', 'Email'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '20%' },
      sortable: true,
      data: 'email',
    },

    {
      title: t('components.users.enabled', 'Abilitato'),
      className: 'd-none d-sm-block text-center',
      style: { width: '10%', minWidth: '7rem' },
      sortable: true,
      sortingKey: 'enabled',
      data: ({ rowData }) => (rowData.enabled ? t('text_yes', 'Si') : t('text_no', 'No')),
    },
    {
      title: t('components.users.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      sortable: true,
      data: ({ rowData }) => this.renderDetails(rowData),
    },
  ]

  renderDetails(rowData) {
    let { username, first_name, last_name, role_name, email, enabled } = rowData
    return (
      <Card className="shadow-lg mb-4 border-0 rounded-lg">
        <Card.Body className="text-center pb-2 pt-2">
          <h4 className="fw-bold text-primary d-flex align-items-center justify-content-center">
            {username}
            <span
              className={`ms-2 rounded-circle ${enabled ? 'bg-success' : 'bg-danger'}`}
              style={{
                width: '12px',
                height: '12px',
                display: 'inline-block',
              }}
              title={enabled ? 'Abilitato' : 'Disabilitato'}></span>
          </h4>
          <p className="text-muted mb-3">{role_name}</p>
        </Card.Body>
        <ListGroup className="list-group-flush text-start">
          <ListGroup.Item>
            <b className="me-1">
              <Trans i18nKey="tenant.components.accounts.first_name">Nome</Trans>:
            </b>
            {first_name}
          </ListGroup.Item>
          <ListGroup.Item>
            <b className="me-1">
              <Trans i18nKey="tenant.components.accounts.last_name">Cognome</Trans>:
            </b>
            {last_name}
          </ListGroup.Item>
          <ListGroup.Item>
            <b className="me-1">
              <Trans i18nKey="tenant.components.accounts.email">Email</Trans>:
            </b>
            {email}
          </ListGroup.Item>
          <ListGroup.Item>
            <b className="me-1">
              <Trans i18nKey="tenant.components.accounts.brand">Brand</Trans>:
            </b>
            {this.props.brands
              .filter(b => (rowData?.brands ?? []).includes(b.id))
              .map(b => b.name)
              .join(', ')}
          </ListGroup.Item>
        </ListGroup>
        <Card.Footer className="text-center bg-light pb-3 pt-3">
          <div className="d-flex justify-content-around flex-wrap">
            {this.actions
              .filter(a => {
                if (a.name === 'separator') {
                  return false
                }
                if (typeof a.visible === 'function') {
                  return a.visible(rowData, a)
                }
                if (typeof a.disabled === 'function') {
                  return a.disabled(rowData, a)
                }
                return a?.visible ?? true
              })
              .map((action, index) => (
                <Button
                  key={index}
                  variant={action.variant}
                  size="sm"
                  title={action.text}
                  onClick={() => action.onClick(rowData)}>
                  <i className={`${action.icon} me-0`}></i>
                </Button>
              ))}
          </div>
        </Card.Footer>
      </Card>
    )
  }

  onFilterChange = filter => this.setState({ filter })

  getData = async (index = 0, chunkSize, sortData, filter) => {
    let { ready, filtered_areas, filtered_roles, filtered_brands } = this.state

    if (!ready) return
    await this.props.dispatch(
      getUsers({ offset: index, limit: chunkSize, sortData, filter, filtered_areas, filtered_roles, filtered_brands })
    )
  }

  addUser = () => {
    this.setState({ form: 'create' })
    this.props.dispatch(toggleShowForm())
  }

  saveUser = async user => {
    user.id ? await this.props.dispatch(updateUser({ user })) : await this.props.dispatch(createUser({ user }))
    this.tableRef.current.refreshData()
  }

  onToggleForm = () => {
    if (this.props.show_form === true) {
      this.props.dispatch(resetCurrentUser())
    }
    this.props.dispatch(toggleShowForm())
  }

  toggleResetPasswordModal = () => {
    this.resetModalRef.current.toggle()
  }

  onCancel = () => {
    this.props.dispatch(resetCurrentUser())
    this.setState({ show_modal: false })
  }

  onConfirmDelete = async () => {
    await this.props.dispatch(deleteUser({ tenant: this.props.tenant, id: this.props.current_user.id }))
    this.tableRef.current.refreshData()
    this.setState({ show_modal: false })
  }

  onChangeFilter = name => values => {
    this.setState({ [name]: values }, () => {
      this.updateFiltersHash()
      this.tableRef?.current?.refreshData()
    })
  }

  handleUpdateErrors = errors => {
    this.props.dispatch(updateErrors(errors))
  }

  onResetFilters = () => {
    this.setState(
      {
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_areas: this.props.competence_areas.map(s => s.id),
        filtered_roles: this.props.roles.map(u => u.id),
      },
      () => {
        this.tableRef?.current?.refreshData()
        this.updateFiltersHash()
      }
    )
  }

  render() {
    let { show_modal, form, filtered_areas, filtered_roles, filtered_brands, filters_hash } = this.state

    let Component = UserForm
    let title = t('components.users.create_user', 'Crea utente')
    if (this.props.current_user.id) {
      title =
        form === 'view'
          ? t('components.users.view_user', 'Visualizza utente')
          : t('components.users.edit_user', 'Modifica utente')
    }
    let menuContentProps = {
      title: title,
      readonly: form === 'view',
      is_management: this.props.is_management_account,
      user: this.props.current_user,
      acls: this.props.acls,
      roles: this.props.roles,
      errors: this.props.errors,
      competence_areas: this.props.competence_areas,
      onSave: this.saveUser,
      closeForm: this.onToggleForm,
      updateErrors: this.handleUpdateErrors,
      forceUseModal: true,
    }
    if (form === 'caps') {
      Component = CapsForm
      menuContentProps = { ...menuContentProps, title: t('components.users.edit_user', 'Modifica permessi') }
    } else if (form === 'target') {
      Component = TargetForm
      menuContentProps = { ...menuContentProps, title: t('components.users.edit_target', 'Modifica obiettivi') }
    } else if (form === 'contract') {
      Component = ContractForm
      menuContentProps = { ...menuContentProps, title: t('components.users.edit_contract', 'Modifica contratti') }
    }
    return (
      <div className="card card-body container-fluid flex-fill d-flex flex-column px-0 pb-0 pt-2 mb-0">
        <div className="d-flex flex-column flex-fill">
          <div className="toolbar px-2 flex-wrap">
            <WithCapabilitiesWrapper has={['manage_users']}>
              <Button className="me-0 me-sm-2" onClick={this.addUser} disabled={this.props.show_form}>
                <i className="fas fa-plus fa-fw text-start me-0 ps-1 ps-sm-0" />
                <span className="d-none d-sm-inline">
                  <Trans i18nKey="buttons.add_account">Aggiungi account</Trans>
                </span>
              </Button>
            </WithCapabilitiesWrapper>

            <FilterGroup
              className="toolbar-item"
              showResetFilters={this.initialFiltersHash !== filters_hash}
              onResetFilters={this.onResetFilters}>
              <CheckboxFilter
                label={t('filter_aree', 'Aree')}
                items={this.props.competence_areas}
                filteredItems={filtered_areas}
                onChangeFilter={this.onChangeFilter('filtered_areas')}
                disabled={this.props.show_form}
              />
              <CheckboxFilter
                label={t('filter_role', 'Ruolo')}
                items={this.props.roles}
                filteredItems={filtered_roles}
                onChangeFilter={this.onChangeFilter('filtered_roles')}
                disabled={this.props.show_form}
              />
              <CheckboxFilter
                label={t('filter_brands', 'Brand')}
                items={this.props.brands}
                filteredItems={filtered_brands}
                onChangeFilter={this.onChangeFilter('filtered_brands')}
                showSearch={true}
              />
            </FilterGroup>

            <div className="toolbar-spacer"></div>
            <div className="flex-fill">
              <SearchButton
                value={this.state.filter}
                onChange={this.onFilterChange}
                disabled={this.props.show_form}
                className="float-md-end"
              />
            </div>
          </div>

          <ResponsiveTable
            ref={this.tableRef}
            className="flex-fill"
            data={this.props.users}
            getData={this.getData}
            totalRecords={this.props.total}
            columns={this.columns}
            showMenu={this.props.show_form}
            modalSize="lg"
            menuContent={Component}
            menuContentProps={menuContentProps}
            rowClasses={rowData => (rowData.enabled ? '' : `text-muted`)}
            filter={this.state.filter}
          />
        </div>

        <Modal backdrop="static" centered show={show_modal} onHide={this.onCancel}>
          <Modal.Header>
            <Modal.Title>
              <Trans i18nKey="tenant.components.accounts.delete_account_modal.title">Elimina account</Trans>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <Trans
                i18nKey="tenant.components.accounts.delete_account_modal.description"
                values={{ user: this.props.current_user?.username }}
                defaults={`Per procedere all'eliminazione dell'utente <1>{{user}}</1>, cliccare sul bottone "Elimina"`}
                components={{ 1: <b /> }}
              />
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onCancel} variant="secondary">
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            <Button onClick={this.onConfirmDelete} variant="danger">
              <Trans i18nKey="buttons.delete">Elimina</Trans>
            </Button>
          </Modal.Footer>
        </Modal>

        <ResetPasswordModal
          ref={this.resetModalRef}
          username={this.props.current_user?.username}
          mountedOnUserForm={true}
        />
      </div>
    )
  }
}
export default connect(mstp)(ManageUsers)
